import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import {Grid} from '@mui/material';

export default function CircularIndeterminate() {
  return (
    <>
    <Grid container flexDirection={'column'} spacing={1} sx={{ display: 'flex', alignItems:"center", justifyContent:"center", height: '100vh' }}>
    <Grid item >
      <CircularProgress />
    </Grid>
    <Grid item>
      Loading....
    </Grid>
    </Grid>
      </>
  );
}